module.exports = __webpack_public_path__ + "static/img/招标-2.071d97f3.png";